import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";

const DialogsWrapper = ({
    open,
    onClose,
    message,
    children,
    ...props
}) => {

    return (
        <Dialog open={open} onClose={onClose} {...props}>
            <DialogTitle>{children}</DialogTitle>
        </Dialog>
    );
};

export default DialogsWrapper;